import React from 'react';
import styles from './Header.module.scss';
import { useTranslation } from '@/i18n';

export const TransactionDetailsHeader: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div>
      <h2 className={styles.title}>{t('transactionDetailsHeader')}</h2>
    </div>
  );
};
